<template>
  <div class="t-resource-container right-container">
    <div class="t-resource-box">
      <div v-show="isList" class="clearfix">
        <div class="head">
          <div class="head-item flex-row-start">
            <div class="step column">第一步</div>
            <div class="flex-between h-select">
              <span>学段：</span>
              <template>
                <el-select
                  v-model="packageQuery.period"
                  placeholder="请选择"
                  class="item-select"
                  @change="onStage"
                >
                  <el-option
                    v-for="item in stageSubjectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </template>
            </div>
            <div class="flex-between h-select">
              <span>年级：</span>
              <template>
                <el-select
                  v-model="packageQuery.grade"
                  placeholder="请选择"
                  class="item-select"
                  :disabled="isTwoDisabled"
                  @change="onGrade"
                >
                  <el-option
                    v-for="item in gradeList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </template>
            </div>
            <div class="flex-between h-select">
              <span>学科：</span>
              <template>
                <el-select
                  v-model="packageQuery.subject"
                  placeholder="请选择"
                  class="item-select"
                  :disabled="isTwoDisabled"
                  @change="onSubject"
                >
                  <el-option
                    v-for="item in subjectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </template>
            </div>
          </div>
          <div class="flex-row-start">
            <div class="head-item-two flex-row-start">
              <div class="step column">第二步</div>
              <div class="flex-between h-select">
                <span>版本：</span>
                <template>
                  <el-select
                    v-model="packageQuery.version"
                    placeholder="请选择"
                    class="item-select"
                    :disabled="isBanbenDisabled"
                    @change="onVersion"
                  >
                    <el-option
                      v-for="item in banBenList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </template>
              </div>
              <div class="flex-between h-ce">
                <span>册：</span>
                <template>
                  <el-select
                    v-model="packageQuery.volume"
                    placeholder="请选择"
                    class="item-select"
                    :disabled="isCeDisabled"
                    @change="onVolume"
                  >
                    <el-option
                      v-for="item in ceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </template>
              </div>
            </div>
            <div class="r-button" @click="onCourseSearch">备课资源检索</div>
          </div>
        </div>
        <div class="list-box clearfix">
          <div class="back-box">资源包列表</div>
          <template>
            <el-table :data="packageData" style="width: 100%">
              <el-table-column prop="periodName" label="学段" width="80">
              </el-table-column>
              <el-table-column prop="gradeName" label="年级" width="100">
              </el-table-column>
              <el-table-column prop="subjectName" label="学科" width="80">
              </el-table-column>
              <el-table-column prop="packageName" label="资源包名称">
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="onLookResourceList(scope.row)"
                    type="text"
                    size="small"
                    >查看资源列表</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="list-page ">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="packageQuery.page"
                :page-size="packageQuery.pageSize"
                :total="packagePageTotal"
                @current-change="onPackagePageChange"
              >
              </el-pagination>
            </div>
          </template>
        </div>
      </div>
      <div class="info-list-container clearfix" v-show="!isList">
        <div class="back-box">
          <el-link
            type="primary"
            :underline="false"
            icon="el-icon-back"
            @click="isList = true"
            >返回资源列表</el-link
          >
        </div>
        <div class="info-list-box">
          <template>
            <el-table :data="resourceList" style="width: 100%">
              <el-table-column prop="name" label="文件名">
                <template slot-scope="scope">
                  <i class="fa c-w fa-folder"> </i>
                  <span class="file-name">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="is_loading" label="" width="100">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    :loading="scope.row.is_loading"
                    @click="onDownload(scope.row)"
                    >下载</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column prop="size" label="大小" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.row.size || "-" }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <!-- <div class="list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.pageSize"
            :total="pageInfoTotal"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { yunPingTaiHeaders, fileSize } from "../../config/common";
export default {
  components: {},
  data() {
    return {
      isList: true,
      query: {
        page: 1,
        pageSize: 10,
      },
      packageQuery: {
        period: "",
        subject: "",
        grade: "",
        version: "",
        volume: "",
        page: 1,
        pageSize: 10,
      },
      packagePageTotal: 0,
      pageInfoTotal: 3,
      stageSubjectList: [],
      subjectList: [],
      gradeList: [],
      banBenList: [],
      ceList: [
        { code: 1, name: "上册" },
        { code: 2, name: "下册" },
        { code: 3, name: "全一册" },
      ],

      isTwoDisabled: true,
      isBanbenDisabled: true,
      isCeDisabled: true,
      packageId: 0,
      packageIng: {},

      value: "",
      packageData: [],
      resourceList: [],
    };
  },
  created() {
    this.getStageSubjectData();
    this.getList();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    getStageSubjectData() {
      this.getRequest("/wenjiaoopne/kc/index/getStageSubject", {
        notIn: "1114",
      })
        .then((result) => {
          this.stageSubjectList = result.data;
        })
        .catch(() => {});
    },
    getGradeList(code) {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-child-dict",
        appId: "100007",
        categoryId: 100200,
        code: code,
      }).then((result) => {
        let _data = result.data,
          min = 0;
        if (code === 12) {
          min = 1;
        }
        let gradeArr = [];
        if (_data.length > 0) {
          _data.forEach((item, index) => {
            if (index > min) {
              gradeArr.push(item);
            }
          });
        }
        this.gradeList = gradeArr;
        this.isTwoDisabled = false;
      });
    },
    getBanBenList(code) {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-child-dict",
        appId: "100007",
        categoryId: 100201,
        code: code,
        level: 2,
      }).then((result) => {
        let _data = result.data;
        _data.shift();
        this.banBenList = _data;
        this.isBanbenDisabled = false;
      });
    },
    // 获取班级列表
    getList() {
      this.getRequest(
        "/wenjiaoopne/kc/teacher/resourcePackage",
        this.packageQuery
      ).then((result) => {
        this.packageData = result.data.list;
        this.packagePageTotal = result.data.total_count;
      });
    },
    getResourceList() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/documents/ext/v2/document/resource-index",
        appId: "101047",
        parentFolderId: 0,
        packageId: this.packageId,
      }).then((result) => {
        this.resourceList = result.data.list;
        this.isList = false;
        this.loading.close();
      });
    },

    addResourceDownloadNote(v,size) {
      this.postRequest("/wenjiaoopne/kc/resource/createResourceDownloadNote", {
        package_id: v.packageId,
        resource_id: v.id,
        user_guid: v.createGuid,
        size: size,
        name: v.name,
        create_name: v.createName,
        package_name:this.packageIng.packageName,
        period: this.packageIng.period,
        subject: this.packageIng.subject,
        grade: this.packageIng.grade,
        version: this.packageIng.version,
        volume: this.packageIng.volume,
        years: this.packageIng.years,
        version_name: this.packageIng.versionName,
        volume_name: this.packageIng.volumeName,
        years_name: this.packageIng.yearsName,
      }).then(() => {

      });
    },

    onStage(v) {
      for (const item of this.stageSubjectList) {
        if (v === item.code) {
          this.subjectList = item.children;
          break;
        }
      }
      this.$set(this.packageQuery, "period", v);
      this.$set(this.packageQuery, "grade", "");
      this.$set(this.packageQuery, "subject", "");
      this.$set(this.packageQuery, "version", "");
      this.$set(this.packageQuery, "volume", "");
      this.isCeDisabled = true;
      this.isBanbenDisabled = true;
      this.banBenList = [];
      this.getGradeList(v);
    },
    onSubject(v) {
      this.banBenList = [];
      this.$set(this.packageQuery, "subject", v);
      this.$set(this.packageQuery, "version", "");
      this.getBanBenList(v);
    },
    onGrade(v) {
      this.$set(this.packageQuery, "grade", v);
      this.$set(this.packageQuery, "volume", "");
      this.isCeDisabled = false;
    },
    onVersion(v) {
      this.$set(this.packageQuery, "version", v);
    },
    onVolume(v) {
      this.$set(this.packageQuery, "volume", v);
    },
    onLookResourceList(v) {
      this.packageId = v.packageId;
      this.packageIng = v;
      this.getResourceList();
    },
    onCourseSearch() {
      this.$set(this.packageQuery, "page", 1);
      this.getList();
    },

    onDownload(v) {
      this.$set(v, "is_loading", true);
      this.downloadRequest(
        "/yunpingtai/documents/ext/v2/document/download-folder",
        {
          packageId: v.packageId,
          corpId: 100007,
          parentFolderId: v.id,
          userGuid: v.createGuid,
        },
        yunPingTaiHeaders(101048)
      )
        .then((result) => {
          if (!result) return;
          let blob = new Blob([result], {
            //下载的文件类型；
            type: "application/zip",
          });
          this.addResourceDownloadNote(v,fileSize(blob.size));
          let fileName = v.name + ".zip";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
            navigator.msSaveBlob(blob);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href); //释放内存
            link.remove();
          }
          this.$set(v, "is_loading", false);
        })
        .catch(() => {});
    },
    // onDownloads(v) {
    //   this.onLoading();
    //   this.downloadRequest("/wenjiaoopne/kc/teacher/resourceDownload", {
    //     package_id: v.packageId,
    //     resource_id: v.id,
    //     name: v.name,
    //     user_guid: v.createGuid,
    //   })
    //     .then((result) => {
    //       if (!result) {
    //         this.loading.close();
    //       }
    //       let blob = new Blob([result], {
    //         //下载的文件类型；
    //         type: "application/zip",
    //       });
    //       let fileName = v.name + ".zip";
    //       if (window.navigator.msSaveOrOpenBlob) {
    //         navigator.msSaveBlob(blob, fileName);
    //         navigator.msSaveBlob(blob);
    //       } else {
    //         var link = document.createElement("a");
    //         link.href = window.URL.createObjectURL(blob);
    //         link.download = fileName;
    //         link.click();
    //         window.URL.revokeObjectURL(link.href); //释放内存
    //         link.remove();
    //       }
    //       this.loading.close();
    //     })
    //     .catch(() => {
    //       this.loading.close();
    //     });
    // },
    onPackagePageChange(v) {
      this.$set(this.packageQuery, "page", v);
      this.getList();
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.t-resource-box {
  margin-top: 20px;
  min-height: 715px;
  background: #f3f6fe;
  padding: 15px 20px 0 20px;
  color: #333;
}
.head-item {
  height: 60px;
  background-color: #fff;
  margin-bottom: 10px;
}
.head-item-two {
  width: 610px;
  height: 60px;
  background-color: #fff;
}
.step {
  width: 100px;
  height: 100%;
  background-color: #a9c9df;
  color: #fff;
}
.h-select {
  margin-left: 20px;
}
.h-ce {
  margin-left: 35px;
}
.r-button {
  width: 240px;
  margin-left: 15px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #fff;
  background-color: #bc4654;
  cursor: pointer;
}
.item-select {
  width: 180px;
}
.file-name {
  margin-left: 10px;
}
.c-w {
  color: #f9bb00;
}
.list-box {
  margin-top: 20px;
  min-height: 600px;
  padding: 0 15px;
  background-color: #fff;
}
.table-header {
  background-color: #fff;
}
.list-page {
  margin: 10px 0;
  float: right;
}
.info-list-container {
  padding: 0 15px;
  min-height: 650px;
  background-color: #fff;
}
.back-box {
  padding: 20px 0;
  background-color: #fff;
}
</style>
